/* SupportTagline.tsx generated by @compiled/babel-plugin v0.29.1 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import SectionMessage from '@atlaskit/section-message';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { BodyNormal, ExternalLink, H4, LinkButton } from '@atlassian/mpac-primitives';
import { useSource } from '@atlassian/mpac-utils';
import * as React from 'react';
import { TEST_ID } from '../../../../../constants';
import { TaglineContainer } from './styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _ = "._19pkhiv4{margin-top:var(--ds-space-400)}";
const sectionMessageContainer = null;
const UnofficialSupport = _ref => {
  let {
    supportDetails,
    atlassianCommunityUrl,
    onCommunityLinkClick
  } = _ref;
  if (supportDetails.hasResources) {
    return /*#__PURE__*/_jsx(BodyNormal, {
      children: "Below are the basic resources shared by the partner through which you can seek assistance in case of any need."
    });
  }
  return /*#__PURE__*/_jsxs(BodyNormal, {
    children: ["If you have any concern or query,", ' ', /*#__PURE__*/_jsx(ExternalLink, {
      href: atlassianCommunityUrl,
      size: "medium",
      onClick: onCommunityLinkClick,
      children: "engage with Atlassian Community"
    }), ' ', "where other customers discuss about apps."]
  });
};
export const SupportTagline = props => {
  const source = useSource();
  const {
    supportDetails: {
      isSupported,
      partner: {
        name: partnerName
      },
      contact: {
        issueTrackerUrl,
        supportTicketSystemUrl,
        emailId
      }
    },
    atlassianCommunityUrl,
    onCommunityLinkClick,
    isEditionsSupported,
    goToPricingTab,
    appPricingDetailsLink
  } = props;
  const {
    enableSelfServeAppEditions
  } = useStatsig();
  const hasOfficialSupport = partnerName && isSupported && (issueTrackerUrl || supportTicketSystemUrl || emailId);
  const getPricingTabLink = () => {
    if (source === 'PRODUCT') {
      // On EMCEE we do not have pricing tab so it's an external redirection to MPAC
      return /*#__PURE__*/_jsx(ExternalLink, {
        href: appPricingDetailsLink,
        children: "Pricing."
      });
    }
    return /*#__PURE__*/_jsx(LinkButton, {
      onClick: goToPricingTab,
      children: "Pricing."
    });
  };
  return /*#__PURE__*/_jsxs(TaglineContainer, {
    "data-testid": TEST_ID.SUPPORT_TAB_SUPPORT_TAGLINE,
    children: [/*#__PURE__*/_jsx(H4, {
      as: "h2",
      children: hasOfficialSupport ? "".concat(partnerName, " provides support for this version of the app") : "".concat(partnerName || 'The partner', " does not provide support for this version of the app")
    }), enableSelfServeAppEditions() && isEditionsSupported && /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_]
      }), /*#__PURE__*/_jsx("div", {
        className: ax(["_19pkhiv4"]),
        children: /*#__PURE__*/_jsx(SectionMessage, {
          children: /*#__PURE__*/_jsxs(BodyNormal, {
            children: ["Standard and Advanced plans for this app may have different support hours. Please check the plan features listed in the ", getPricingTabLink()]
          })
        })
      })]
    }), !hasOfficialSupport && /*#__PURE__*/_jsx(UnofficialSupport, {
      supportDetails: props.supportDetails,
      atlassianCommunityUrl: atlassianCommunityUrl,
      onCommunityLinkClick: onCommunityLinkClick
    })]
  });
};